<template>
    <section
        :class="[
            'container-fluid',
            'content-type-15',
            !paywall && !unavailable ? 'toggleable' : '',
            loading ? 'loading' : '',
            cssClass,
            toggle ? 'expanded' : 'collapsed',
            $slots['section-actions'] ? 'has-actions' : ''
        ]"
        ref="sectionContainer"
    >
        <div class="container">
            <div class="row row-title" @click="toggleSection">
                <div class="section-title">
                    <slot name="section-title"></slot>
                </div>
                <div class="section-actions" @click.stop>
                    <slot v-if="!$slots['section-noresults'] && toggle && !paywall && !unavailable" name="section-actions"></slot>
                    <div @click="toggleSection" v-if="!paywall && !unavailable && !loading" class="toggle-button" :class="[toggle ? 'visible' : 'hidden']">
                        <div class="toggle-icon"></div>
                    </div>
                    <router-link :to="{ name: 'subscriptions' }" v-if="paywall" class="paywall-button">
                        <div class="icon-lock-pos"></div>
                    </router-link>
                    <div v-else-if="!loading && unavailable" class="not-available-text">
                        <div>{{ $t('common.unavailable') }}</div>
                    </div>

                    <div v-if="loading && !toggle" class="loading-icon">
                        <div class="loading-spinner-type-2"></div>
                    </div>
                </div>
            </div>

            <div class="widget-section-helper" v-show="!loading && toggle && loaded">
                <slot name="section-content"></slot>
            </div>

            <div v-show="!loading && $slots['section-noresults'] && toggle" class="row row-noresults">
                <div class="section-noresults">
                    <slot name="section-noresults"></slot>
                </div>
            </div>

            <div v-show="loading && toggle" class="row row-loading">
                <LoadingSection :showMessage="showMessage" :message="loadingText" />
            </div>
        </div>
    </section>
</template>

<script>
    import { nextTick } from 'vue';
    import LoadingSection from '@/components/sections/LoadingSection';

    export default {
        name: "WidgetSection",
        emits: ['toggle', 'loading-start'],
        components: {
           LoadingSection 
        },
        props: {
            loaded: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            },
            loadingText: {
                type: String,
                default: null
            },
            defaultToggle: {
                type: Boolean,
                default: true
            },
            cssClass: {
                type: String,
                required: false,
            },
            paywall: {
                type: Boolean,
                default: false
            },
            unavailable: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                toggle: this.defaultToggle
            }
        },
        computed: {
            showMessage() {
                return !!this.loadingText;
            },
        },
        methods: {
            toggleSection() {
                nextTick(() => {
                    if(this.paywall || this.unavailable) { return; }

                    if (this.loaded && !this.loading) {
                        this.toggle = !this.toggle;
                        this.$emit('toggle', this.toggle);
                    } else if (!this.loading) {
                        this.$emit('loading-start', this.toggle);
                    }
                });
            },
            forcefullyOpenSection() {
                nextTick(() => {
                    if(this.paywall || this.unavailable) { return; }

                    if (this.loaded && !this.loading) {
                        this.toggle = !this.toggle;
                        this.$emit('toggle', this.toggle);
                    } else if (!this.loading) {
                        this.$emit('loading-start', this.toggle);
                    }
                });
            }
        },
        watch: {
            unavailable(newValue) {
                if(newValue) {
                    this.toggle = false;
                }
            }
        },
        mounted() {
            if(this.paywall || this.unavailable) {
                this.toggle = false;
            }
        }
    }
</script>